import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import * as api from "../api/api";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";

export default function Tags(props) {
  const { language } = useLanguage();
  const pageTitle = "Tags";

  const { teams, handleSelectedTeams } = props;
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [teamOptions, setTeamOptions] = useState([]);
  useEffect(() => {
    setSelectedTeams(teams);
  }, [teams]);

  useEffect(() => {
    // fetch all available teams in the database so we can choose from
    api.getAllTeams().then((response) => {
      console.log(response.data.object);
      let arr1 = response.data.object.map((team) => {
        return {
          teamId: team.teamId,
          name: team.name,
        };
      });
      // let arr2 = arr1.filter((t) => !selectedTeams.includes(t));
      setTeamOptions(arr1);
    });
  }, []);

  // useEffect(() => {
  //   handleSelectedTeams(selectedTeams)
  //   console.log("selected teams are : ", selectedTeams);
  // }, [selectedTeams]);
  const myFunc = (val) => {
    setSelectedTeams(val);
    handleSelectedTeams(val);
  };

  console.log("teams are : ", teams);
  return (
    <Stack spacing={3} sx={{ minWidth: "30em" }}>
      <Autocomplete
        multiple
        isOptionEqualToValue={(option, value) => option.teamId === value.teamId}
        id="tags-outlined"
        options={teamOptions ? teamOptions : []}
        getOptionLabel={(option) => option.name}
        // defaultValue= {teams ? teams : []}
        value={selectedTeams ? selectedTeams : []}
        onChange={(event, newValue) => {
          myFunc(newValue);
        }}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
            label={strings[pageTitle][language].assignedTeams}
            // placeholder="Assigned teams"
          />
        )}
      />
    </Stack>
  );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
